import { Box } from "@mui/material";

export default function Accountants({ countPending, countReparacion }) {
  return (
    <>
      <Box
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          color: "#E65100",
          backgroundColor: "#FFF4E5",
          padding: "3px 8px",
          borderRadius: "16px",
        }}
      >
        Pendientes : {countPending}
      </Box>
      <Box
        sx={{
          fontWeight: 400,
          fontSize: "14px",
          color: "#4527A0",
          backgroundColor: "#EDE7F6",
          padding: "3px 8px",
          borderRadius: "16px",
        }}
      >
        En reparación : {countReparacion}
      </Box>
    </>
  );
}
